import { z } from 'zod'

/** İzin tipi — rota ve AI eylem kataloğu (LLM gövde şemasını görür) ortak kullanır */
export const CreateLeaveTypeSchema = z.object({
  code: z.string().min(2).max(30),
  name: z.string().min(2).max(100),
  description: z.string().optional(),
  annualEntitlement: z.number().min(0).max(365),
  requiresApproval: z.boolean().optional().default(true),
  isPaid: z.boolean().optional().default(true),
})

export const UpdateLeaveTypeSchema = CreateLeaveTypeSchema.partial().omit({ code: true }).extend({
  isActive: z.boolean().optional(),
})

// ─── İzin talepleri (rota + mobil ortak) ───────────────────────────────────────

const isoDay = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'Tarih YYYY-AA-GG biçiminde olmalıdır.').refine((v) => !Number.isNaN(Date.parse(v)), 'Geçerli bir tarih giriniz.')

export const CreateLeaveRequestSchema = z.object({
  leaveTypeId: z.string().uuid(),
  startDate: isoDay,
  endDate: isoDay,
  reason: z.string().max(500).optional(),
})
export const UpdateLeaveRequestSchema = CreateLeaveRequestSchema.partial()
export const RejectLeaveSchema = z.object({
  reason: z.string().min(5, 'Ret nedeni en az 5 karakter olmalıdır.').max(500),
})
export const InitLeaveBalanceSchema = z.object({
  userId: z.string().uuid(),
  leaveTypeId: z.string().uuid(),
  year: z.number().int().min(2000).max(2100),
  entitlementDays: z.number().min(0).max(365),
  carryforwardDays: z.number().min(0).max(365).optional().default(0),
})

export type CreateLeaveRequestInput = z.infer<typeof CreateLeaveRequestSchema>
export type UpdateLeaveRequestInput = z.infer<typeof UpdateLeaveRequestSchema>
export type RejectLeaveInput = z.infer<typeof RejectLeaveSchema>
